import React from 'react';

function Content({ children }) {
    return (
        <div className="App-content">
            {children}
        </div>
    );
}

export default Content;
